import useLocalStorage from "./useLocalStorage";

const useShortcuts = () => {
	const [shortcuts, setShortcuts] = useLocalStorage("shortcuts", "true");

	const toggleShortcuts = () => {
		setShortcuts((prevTheme) => (prevTheme === "true" ? "false" : "true"));
	};

	return {
		isShortcutsOn: shortcuts === "true",
		toggleShortcuts,
	};
};

export default useShortcuts;
